import { paramCase } from 'change-case'
import { oneOf, string, object, func, bool, array } from 'prop-types'
import { kuiperClassNames } from '@opallabs/kuiper'
import { Desktop } from './display'
import { baseStyles } from './styles'

const displays = {
  desktopStandard: Desktop,
  default: Desktop,
}

const matchDisplay = (display) => displays[display] || displays.default

export const AssetAndCopy = ({
  accountImage,
  accountName,
  assets,
  content,
  display,
  isPresenting = false,
  onExpandAsset = () => null,
  onRemoveAsset = () => null,
  readOnly = false,
  updateCaption = () => null,
  updateText = () => null,
}) => {
  const RenderDisplay = matchDisplay(display)

  return (
    <div
      css={baseStyles(display, isPresenting)}
      className={kuiperClassNames(
        'generic generic-asset-and-copy',
        `generic-${paramCase(display)}`
      )}
    >
      <RenderDisplay
        accountImage={accountImage}
        accountName={accountName}
        assets={assets}
        content={content}
        isPresenting={isPresenting}
        onExpandAsset={onExpandAsset}
        onRemoveAsset={onRemoveAsset}
        readOnly={readOnly}
        onContentChange={(val) => updateText(val, 'content')}
        updateCaption={(val, assetId) => updateCaption(val, assetId)}
      />
    </div>
  )
}

AssetAndCopy.propTypes = {
  accountImage: object,
  accountName: string,
  assets: array,
  content: string,
  display: oneOf(['desktopStandard']),
  isPresenting: bool,
  onExpandAsset: func,
  onRemoveAsset: func,
  readOnly: bool,
  updateCaption: func,
  updateText: func,
}
